<template>
  <div class="body-width divcss5">
    <div>
      <div class="div-row div-bottom news-Medium-24">
        大连市科技局专家组一行来我司考察
        <!-- <span class="news-Regular-14">作者：何舒 来源：科技处 添加时间：2019-05-09 09:13:27</span> -->
      </div>
           <div class="div-text-left news-Regular-14b6">
            <span>2020-04-26</span><span class="div-padding-left">大连海大智龙科技有限公司</span>
           </div>
      <div class="div-line  divcss5"></div>
      <div class="div-row div-bottom10">
          <p class="indentation">
         4月26日下午13：30大连市科技局专家组到公司考察申报的重大成果转化专项相关内容。
        </p>
        
      </div>
      <div class="div-row div-bottom10">
        <div class="  div-top box2">
          <div class="div-margin ">
            <img src="../../../assets/images/news15/1.png" />
          </div>
        </div>
      </div>
      <div class="div-row div-bottom10">
        <div class=" div-top box2">
          <div class="div-margin ">
            <img src="../../../assets/images/news15/2.png" />
          </div>
        </div>
      </div>
         <div class="div-row div-bottom10">
        <div class=" div-top box2">
                 <div class="div-margin ">
             <img src="../../../assets/images/news15/3.png" />
          </div>
        </div>
      </div>
         <div class="div-row div-bottom10">
        <div class=" div-top box2">
          <div class="div-margin ">
            <img src="../../../assets/images/news15/4.png" />
          </div>
        </div>
      </div>

        <div class="div-row div-bottom10">
        <div class=" div-top box2">
          <div class="div-margin ">
            <img src="../../../assets/images/news15/5.png" />
      
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {

      };
    },
    methods: {

    },
  };

</script>

<style scoped>
  .fl {
    float: right;
    margin-right: 20px;
  }

  .fy {
    text-align: center;
    margin-top: 30px;
  }

  .title {
    height: 100%;
  }

  .div-width {
    width: 75%;
  }



  .div-line {
    background: #E6E6E6;
    height: 1px;
    width: 100%;

  }

  .div-bottom10 {
    padding-top: 10px;
  }

  .div-bottom30 {
    padding-top: 30px;
    padding-bottom: 30px;
  }

  .div-top30 {
    padding-top: 30px;
  }
  img {
    vertical-align: middle;
    border-style: none;
    width: 100%; 
  }
</style>



// WEBPACK FOOTER //
// src/components/contentcoms/news2020/news15.vue